import { PageHeader } from 'antd'
import styled from 'styled-components'

const HeaderPage = styled(PageHeader)`
  background-color: #fff;
  margin-bottom: 24px;
`
export default HeaderPage
